import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { TraiesteHero } from '../components/traieste/TraiesteHero';
import { TraiesteProblem } from '../components/traieste/TraiesteProblem';
import { TraiesteCurriculum } from '../components/traieste/TraiesteCurriculum';
import { TraiesteBenefits } from '../components/traieste/TraiesteBenefits';
import { TraiesteAbout } from '../components/traieste/TraiesteAbout';
import { TraiesteForWho } from '../components/traieste/TraiesteForWho';
import { TraiestePricing } from '../components/traieste/TraiestePricing';
import { TraiesteTestimonials } from '../components/traieste/TraiesteTestimonials';
import { TraiesteFAQ } from '../components/traieste/TraiesteFAQ';
export function TraiestePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2417">
      <Header data-id="element-2418" />
      <main data-id="element-2419">
        <TraiesteHero data-id="element-2420" />
        <TraiesteProblem data-id="element-2421" />
        <TraiesteCurriculum data-id="element-2422" />
        <TraiesteBenefits data-id="element-2423" />
        <TraiesteAbout data-id="element-2424" />
        <TraiesteForWho data-id="element-2425" />
        <TraiestePricing data-id="element-2426" />
        <TraiesteTestimonials data-id="element-2427" />
        <TraiesteFAQ data-id="element-2428" />
      </main>
      <Footer data-id="element-2429" />
    </div>;
}